// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ecl-loader {
   width: 100%;
   height: 100%;
   display: flex;
   flex-direction: column;
   justify-content: center;
   align-items: center;
}

.ecl-loader img {
   max-width: 100px;
   max-height: 100px;
   min-width: 2rem;
   min-height: 2rem;
}

.ecl-loader .themed-svg-container {
   max-width: 100px;
   max-height: 100px;
   min-width: 2rem;
   min-height: 2rem;   
}

.ecl-loader .themed-svg-container svg {
   height: 100%;
   width: 100%;
}

.ecl-loader .spinnable-image {
   animation: .75s linear 0s infinite ECLspin;
}

.ecl-loader p {
   font-size: 1.5rem;
}

@keyframes ECLspin {
   0% {
      transform: rotate(0);
   }
   100% {
      transform: rotate(360deg);
   }
}`, "",{"version":3,"sources":["webpack://./src/eclComponents/Widgets/ECLLoader/ECLLoader.css"],"names":[],"mappings":"AAAA;GACG,WAAW;GACX,YAAY;GACZ,aAAa;GACb,sBAAsB;GACtB,uBAAuB;GACvB,mBAAmB;AACtB;;AAEA;GACG,gBAAgB;GAChB,iBAAiB;GACjB,eAAe;GACf,gBAAgB;AACnB;;AAEA;GACG,gBAAgB;GAChB,iBAAiB;GACjB,eAAe;GACf,gBAAgB;AACnB;;AAEA;GACG,YAAY;GACZ,WAAW;AACd;;AAEA;GACG,0CAA0C;AAC7C;;AAEA;GACG,iBAAiB;AACpB;;AAEA;GACG;MACG,oBAAoB;GACvB;GACA;MACG,yBAAyB;GAC5B;AACH","sourcesContent":[".ecl-loader {\r\n   width: 100%;\r\n   height: 100%;\r\n   display: flex;\r\n   flex-direction: column;\r\n   justify-content: center;\r\n   align-items: center;\r\n}\r\n\r\n.ecl-loader img {\r\n   max-width: 100px;\r\n   max-height: 100px;\r\n   min-width: 2rem;\r\n   min-height: 2rem;\r\n}\r\n\r\n.ecl-loader .themed-svg-container {\r\n   max-width: 100px;\r\n   max-height: 100px;\r\n   min-width: 2rem;\r\n   min-height: 2rem;   \r\n}\r\n\r\n.ecl-loader .themed-svg-container svg {\r\n   height: 100%;\r\n   width: 100%;\r\n}\r\n\r\n.ecl-loader .spinnable-image {\r\n   animation: .75s linear 0s infinite ECLspin;\r\n}\r\n\r\n.ecl-loader p {\r\n   font-size: 1.5rem;\r\n}\r\n\r\n@keyframes ECLspin {\r\n   0% {\r\n      transform: rotate(0);\r\n   }\r\n   100% {\r\n      transform: rotate(360deg);\r\n   }\r\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
